import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M2.75 5.673a.75.75 0 0 0-1.5 0v8.187c0 .966.784 1.75 1.75 1.75h10a1.75 1.75 0 0 0 1.75-1.75V5.673a.75.75 0 0 0-1.5 0v8.187a.25.25 0 0 1-.25.25H3a.25.25 0 0 1-.25-.25V5.673Z" }, null, -1), l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M8 9.071c.71 0 1.284-.574 1.284-1.283 0 .008 0 .006-.003-.006a3.057 3.057 0 0 0-.112-.42 12.485 12.485 0 0 0-.424-1.082A33.396 33.396 0 0 0 8 4.708c-.261.52-.522 1.064-.744 1.572-.182.415-.327.784-.425 1.083a3.055 3.055 0 0 0-.112.419c-.002.012-.002.014-.002.006 0 .709.574 1.283 1.283 1.283Zm0 1.5a2.783 2.783 0 0 0 2.784-2.783c0-.878-1.125-3.171-1.944-4.726a.942.942 0 0 0-1.679 0c-.82 1.555-1.944 3.848-1.944 4.726A2.783 2.783 0 0 0 8 10.57Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n,
  l
];
function d(r, s) {
  return t(), o("svg", c, [...a]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
